import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from './Header';
import Sidebar from './Sidebar';
import Breadcrumb from './Breadcrumb';
import './MainLayout.css';

/**
 * 主布局组件
 * 包含头部导航、侧边栏和内容区域
 * @returns {JSX.Element} 返回主布局组件
 */
function MainLayout() {
    const { isAuthenticated } = useSelector((state) => state.user);

    // 使用 isAuthenticated 进行路由保护
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="main-layout">
            <Header />
            <div className="d-flex">
                <Sidebar />
                <div className="content-area flex-grow-1 p-3">
                    <Breadcrumb />
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default MainLayout;
